import App from "App";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import config from "./config";

// Log the config.
// console.log('config', JSON.stringify(config, null, 2));

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
